module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "banner"
  }, [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdd),
      expression: "isAdd"
    }],
    staticClass: "add_banner pad_left",
    attrs: {
      "span": 24
    }
  }, [_c('section', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('p', {
    staticStyle: {
      "width": "102px",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$route.query.type == 1 ? "商家资料查看" : "商家资料审核"))])])], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "30px"
    }
  }, [_c('span', {
    staticClass: "red_info"
  }), _vm._v(" "), _c('strong', {
    staticStyle: {
      "margin-left": "5px",
      "margin-top": "-1px"
    }
  }, [_vm._v(_vm._s(_vm.$route.query.type == 1 ? "申请商家入驻资料查看" : "申请商家入驻资料填写"))])]), _vm._v(" "), _c('el-form', {
    ref: "editForm",
    staticStyle: {
      "margin-left": "100px",
      "margin-top": "30px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商家名称：",
      "required": _vm.bloon,
      "show-message": _vm.bloon1,
      "prop": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "560px"
    },
    attrs: {
      "disabled": _vm.disabled,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "代理品牌：",
      "required": _vm.bloon,
      "show-message": _vm.bloon1,
      "prop": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBdName),
      expression: "showBdName"
    }]
  }, [_c('span', {
    staticStyle: {
      "color": "#F56C6C"
    }
  }, [_vm._v("已选择：")]), _vm._v(" "), _vm._l((_vm.xuanze), function(item, index) {
    return _c('span', {
      key: index
    }, [_vm._v(_vm._s(item.Name) + ";")])
  })], 2)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "公司所在地：",
      "required": _vm.bloon,
      "show-message": _vm.bloon1,
      "prop": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "disabled": _vm.disabled,
      "placeholder": ""
    },
    on: {
      "change": _vm.selectcity
    },
    model: {
      value: (_vm.form.ProvinceId),
      callback: function($$v) {
        _vm.$set(_vm.form, "ProvinceId", $$v)
      },
      expression: "form.ProvinceId"
    }
  }, _vm._l((_vm.provinceoptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "dur_title",
    staticStyle: {
      "margin": "0 11px"
    }
  }, [_vm._v("省")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "disabled": _vm.disabled,
      "placeholder": ""
    },
    on: {
      "change": _vm.selectzore
    },
    model: {
      value: (_vm.form.CityId),
      callback: function($$v) {
        _vm.$set(_vm.form, "CityId", $$v)
      },
      expression: "form.CityId"
    }
  }, _vm._l((_vm.cityoptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "dur_title",
    staticStyle: {
      "margin": "0 11px"
    }
  }, [_vm._v("市")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "disabled": _vm.disabled,
      "placeholder": ""
    },
    model: {
      value: (_vm.form.ZoneId),
      callback: function($$v) {
        _vm.$set(_vm.form, "ZoneId", $$v)
      },
      expression: "form.ZoneId"
    }
  }, _vm._l((_vm.Zoneoptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "dur_title",
    staticStyle: {
      "margin": "0 11px"
    }
  }, [_vm._v("区/县")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "560px"
    },
    attrs: {
      "disabled": _vm.disabled,
      "placeholder": "请填写详细地址",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.address),
      callback: function($$v) {
        _vm.$set(_vm.form, "address", $$v)
      },
      expression: "form.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "公司电话：",
      "required": _vm.bloon,
      "show-message": _vm.bloon1,
      "prop": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "360px"
    },
    attrs: {
      "disabled": _vm.disabled,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.OpeningBank),
      callback: function($$v) {
        _vm.$set(_vm.form, "OpeningBank", $$v)
      },
      expression: "form.OpeningBank"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "负责人姓名：",
      "required": _vm.bloon,
      "show-message": _vm.bloon1,
      "prop": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "360px"
    },
    attrs: {
      "disabled": _vm.disabled,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.Contacts),
      callback: function($$v) {
        _vm.$set(_vm.form, "Contacts", $$v)
      },
      expression: "form.Contacts"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "负责人手机号：",
      "required": _vm.bloon,
      "show-message": _vm.bloon1,
      "prop": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "360px"
    },
    attrs: {
      "disabled": _vm.disabled,
      "auto-complete": "off",
      "type": "email"
    },
    model: {
      value: (_vm.form.Phone),
      callback: function($$v) {
        _vm.$set(_vm.form, "Phone", $$v)
      },
      expression: "form.Phone"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "30px"
    }
  }, [_c('span', {
    staticClass: "red_info"
  }), _vm._v(" "), _c('strong', {
    staticStyle: {
      "margin-left": "5px",
      "margin-top": "-1px"
    }
  }, [_vm._v(_vm._s(_vm.$route.query.type == 1 ? "商家运营负责人账号查看" : "商家运营负责人账号开通申请"))])]), _vm._v(" "), _c('el-form', {
    ref: "editForm",
    staticStyle: {
      "margin-left": "90px",
      "margin-top": "30px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名:",
      "required": _vm.bloon,
      "show-message": _vm.bloon1,
      "prop": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "360px"
    },
    attrs: {
      "disabled": _vm.disabled,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.yunname),
      callback: function($$v) {
        _vm.$set(_vm.form, "yunname", $$v)
      },
      expression: "form.yunname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "性别:",
      "required": _vm.bloon,
      "show-message": _vm.bloon1,
      "prop": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "background": "#fff",
      "width": "360px"
    },
    attrs: {
      "disabled": _vm.disabled,
      "placeholder": ""
    },
    model: {
      value: (_vm.form.yunGender),
      callback: function($$v) {
        _vm.$set(_vm.form, "yunGender", $$v)
      },
      expression: "form.yunGender"
    }
  }, _vm._l((_vm.sex), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号:",
      "required": _vm.bloon,
      "show-message": _vm.bloon1,
      "prop": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "360px"
    },
    attrs: {
      "disabled": _vm.disabled,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.yunPhoneNumber),
      callback: function($$v) {
        _vm.$set(_vm.form, "yunPhoneNumber", $$v)
      },
      expression: "form.yunPhoneNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮箱:",
      "required": _vm.bloon,
      "show-message": _vm.bloon1,
      "prop": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "360px"
    },
    attrs: {
      "disabled": _vm.disabled,
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.yunmailbox),
      callback: function($$v) {
        _vm.$set(_vm.form, "yunmailbox", $$v)
      },
      expression: "form.yunmailbox"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "margin-left": "170px"
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.query.type == 1 ? false : true),
      expression: "$route.query.type==1?false:true"
    }],
    staticClass: "search_btn",
    on: {
      "click": function($event) {
        return _vm.Auditpass()
      }
    }
  }, [_vm._v("审核通过")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$route.query.type == 1 ? false : true),
      expression: "$route.query.type==1?false:true"
    }],
    staticClass: "search_btn",
    on: {
      "click": function($event) {
        return _vm.bohui()
      }
    }
  }, [_vm._v("驳回")]), _vm._v(" "), _c('p', {
    staticClass: "search_btn",
    on: {
      "click": function($event) {
        return _vm.closeBan()
      }
    }
  }, [_vm._v("取消")])])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.adopt),
      expression: "adopt"
    }],
    staticClass: "add_banner pad_left",
    attrs: {
      "span": 24
    }
  }, [_c('section', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('p', {
    staticStyle: {
      "width": "102px",
      "text-align": "center"
    }
  }, [_vm._v("商家资料审核")])])], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "30px"
    }
  }, [_c('span', {
    staticClass: "red_info"
  }), _vm._v(" "), _c('strong', {
    staticStyle: {
      "margin-left": "5px",
      "margin-top": "-1px"
    }
  }, [_vm._v("合作信息")])]), _vm._v(" "), _c('el-form', {
    ref: "editForm",
    staticStyle: {
      "margin-left": "100px",
      "margin-top": "30px"
    },
    attrs: {
      "model": _vm.form,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "合作类型：",
      "required": _vm.bloon,
      "show-message": _vm.bloon1
    }
  }, [_c('el-select', {
    staticStyle: {
      "background": "#fff",
      "width": "200px"
    },
    attrs: {
      "placeholder": ""
    },
    on: {
      "click": function($event) {
        return _vm.showtime()
      }
    },
    model: {
      value: (_vm.form.operatypeid),
      callback: function($$v) {
        _vm.$set(_vm.form, "operatypeid", $$v)
      },
      expression: "form.operatypeid"
    }
  }, _vm._l((_vm.coperation), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.form.operatypeid == 2),
      expression: "this.form.operatypeid == 2"
    }],
    attrs: {
      "label": "合作周期：",
      "required": _vm.bloon,
      "show-message": _vm.bloon1,
      "prop": ""
    }
  }, [_c('el-col', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "type": "date",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.date1),
      callback: function($$v) {
        _vm.$set(_vm.form, "date1", $$v)
      },
      expression: "form.date1"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    staticStyle: {
      "width": "40px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/aicon10_03.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('el-col', {
    staticClass: "line dur_title",
    staticStyle: {
      "width": "35px"
    },
    attrs: {
      "span": 1
    }
  }, [_vm._v("至")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.date2),
      callback: function($$v) {
        _vm.$set(_vm.form, "date2", $$v)
      },
      expression: "form.date2"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "line",
    staticStyle: {
      "width": "40px"
    },
    attrs: {
      "span": 1
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/aicon10_03.jpg"),
      "alt": ""
    }
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "回款类型：",
      "required": _vm.bloon,
      "show-message": _vm.bloon1,
      "prop": ""
    }
  }, [_c('el-select', {
    staticStyle: {
      "background": "#fff",
      "width": "400px"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.huikuanid),
      callback: function($$v) {
        _vm.$set(_vm.form, "huikuanid", $$v)
      },
      expression: "form.huikuanid"
    }
  }, _vm._l((_vm.huikuanoptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "margin-left": "130px"
    }
  }, [_c('p', {
    staticClass: "search_btn",
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    }
  }, [_vm._v("返回上一步")]), _vm._v(" "), _c('p', {
    staticClass: "search_btn",
    on: {
      "click": function($event) {
        return _vm.Submit()
      }
    }
  }, [_vm._v("提交")])])], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "overflow",
    staticStyle: {
      "width": "1545px",
      "margin-left": "205px",
      "margin-top": "50px"
    },
    attrs: {
      "title": "代理品牌",
      "visible": _vm.outerVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.outerVisible = $event
      }
    }
  }, [_c('div', [_c('el-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "请输入关键字",
      "type": "email"
    },
    model: {
      value: (_vm.key1),
      callback: function($$v) {
        _vm.key1 = $$v
      },
      expression: "key1"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "span",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.find()
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('span', {
    staticClass: "span",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.sure
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('span', {
    staticClass: "span",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.outerVisible = false
      }
    }
  }, [_vm._v("取消")])], 1), _vm._v(" "), _c('div', {
    staticClass: "bdname"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v("品牌名称")])]), _vm._v(" "), _c('div', {
    staticClass: "check_box"
  }, [
    [_c('div', {
      staticStyle: {
        "margin": "15px 0"
      }
    }), _vm._v(" "), _c('el-checkbox-group', {
      attrs: {
        "fill": "#F56C6C",
        "text-color": "#fff"
      },
      on: {
        "change": _vm.handleCheckedCitiesChange1
      },
      model: {
        value: (_vm.checkedCities),
        callback: function($$v) {
          _vm.checkedCities = $$v
        },
        expression: "checkedCities"
      }
    }, _vm._l((_vm.cities), function(city, index) {
      return _c('el-checkbox', {
        key: index,
        staticClass: "shezhi",
        staticStyle: {
          "margin-top": "10px"
        },
        attrs: {
          "text-color": "#F56C6C",
          "title": city.Name,
          "label": city
        }
      }, [_vm._v(_vm._s(city.Name))])
    }), 1)]
  ], 2), _vm._v(" "), _c('div', {
    staticClass: "allchange"
  }, [_c('el-checkbox', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "indeterminate": false,
      "text-color": "#F56C6C"
    },
    on: {
      "change": _vm.handleCheckAllChange
    },
    model: {
      value: (_vm.checkAll),
      callback: function($$v) {
        _vm.checkAll = $$v
      },
      expression: "checkAll"
    }
  }, [_vm._v("全选")]), _vm._v(" "), _c('span', {
    ref: "clear",
    staticClass: "span1",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.clear()
      }
    }
  }, [_vm._v("清空")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "width": "30%",
      "title": "内层 Dialog",
      "visible": _vm.innerVisible,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.innerVisible = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "确认",
      "visible": _vm.dialogVisible1,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible1 = $event
      }
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "140px",
      "display": "inline-block",
      "height": "100px",
      "line-height": "100px"
    }
  }, [_vm._v("代理品牌选择完成，您是否选择确认？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.dialogVisible1 = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticClass: "button",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.sure1()
      }
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "取消",
      "visible": _vm.dialogVisible2,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible2 = $event
      }
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "40px",
      "display": "inline-block",
      "height": "100px",
      "line-height": "100px"
    }
  }, [_vm._v("代理品牌选择完成，取消后将不记载您的数据，您是否确定取消么？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.dialogVisible2 = false;
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticClass: "button",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.sure2()
      }
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "清空",
      "visible": _vm.dialogVisible3,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible3 = $event
      }
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "85px",
      "display": "inline-block",
      "height": "100px",
      "line-height": "100px"
    }
  }, [_vm._v("清空后将不保留您选择的代理品牌结果，您是否确认？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.dialogVisible3 = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    staticClass: "button",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.clear1()
      }
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-763688aa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/staging/examine.vue
// module id = 1716
// module chunks = 3